import React, { createContext, useCallback, useContext, useState } from "react";
import { meGet } from "services/me";

type Props = {} & React.InputHTMLAttributes<HTMLInputElement>;

interface AuthContextData {
  userName: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  userRole: string;
  setUserRole: React.Dispatch<React.SetStateAction<string>>;
  reloadContextData: () => void;
  userCoupon: string;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC<Props> = ({ children }) => {
  const [userName, setUserName] = useState<any>(null);
  const [userRole, setUserRole] = useState<any>(null);
  const [userCoupon, setUserCoupon] = useState<any>(null);

  const getStates = useCallback(async () => {
    try {
      const { data } = await meGet();
      setUserName(data.name);
      setUserRole(data.role);
      setUserCoupon(data?.coupon);
    } catch (_) {}
  }, []);

  const reloadContextData = () => {
    setUserName(null);
    setUserRole(null);
    setUserCoupon(null);
    getStates();
  };

  return (
    <AuthContext.Provider
      value={{
        userName,
        setUserName,
        userRole,
        setUserRole,
        reloadContextData,
        userCoupon,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider.");
  }
  return context;
}

export { AuthProvider, useAuth };
export default AuthContext;
